import { z } from 'zod';

import {
	type HomeBodyControl,
	homeBodyControlSchema,
} from './home-component.schema';

export type HomeBodyColumn = {
	columnCount: number;
	controls: Array<HomeBodyControl | Record<string, unknown>>;
};

export type HomeBodyRow = {
	columns: HomeBodyColumn[];
	columnCount: number;
	tweakColumnsForMobile?: boolean;
	addDivider?: boolean;
};

export type HomeBodyMain = {
	theme?: string;
	template?: string;
	rows: HomeBodyRow[];
	header?: {
		type?: string;
		heading?: string;
	} | null;
};

export type HomePageBody = {
	main: HomeBodyMain;
};

export const homeBodyColumnSchema: z.ZodType<HomeBodyColumn> = z.object({
	columnCount: z.number(),
	// Accept any control payloads from freeform; typed narrowing happens in the home composer.
	controls: z.array(z.union([homeBodyControlSchema, z.record(z.unknown())])),
});

export const homeBodyRowSchema: z.ZodType<HomeBodyRow> = z.object({
	columns: z.array(homeBodyColumnSchema),
	columnCount: z.number(),
	tweakColumnsForMobile: z.boolean().optional(),
	addDivider: z.boolean().optional(),
});

export const homeBodyMainSchema: z.ZodType<HomeBodyMain> = z.object({
	theme: z.string().optional(),
	template: z.string().optional(),
	rows: z.array(homeBodyRowSchema),
	header: z
		.object({
			type: z.string().optional(),
			heading: z.string().optional(),
		})
		.optional()
		.nullable(),
});

export const homePageBodySchema: z.ZodType<HomePageBody> = z.object({
	main: homeBodyMainSchema,
});
